<form style="margin: 0px 0px 30px 0px;" name="preCheckoutInfo" class="needs-validation" [formGroup]="preCheckoutFormInfo" (ngSubmit)="onSubmit()" novalidate>
    <label [class.label-invalid]="!validInfo()">{{questionSelected.pergunta}}</label>
    <div class="d-flex align-items-center input-group has-validations">
        <input mask="{{questionSelected.mask}}" class="form-control" aria-describedby="basic-question" [class.disabled-input]="usuarioBloqueado" type="text" placeholder="{{questionSelected.placeHolder}}" formControlName="info" id="info" 
        [class.input-invalid]="!validInfo()" required/>

        <div class="input-group-append">
            <span class="input-group-text" id="basic-question">
                <fa-icon class="float-end" [icon]="['fas', 'question']" size="lg"></fa-icon>
            </span>
        </div>
    </div>

    <div class="container">
        <div class="row">
          <div class="col-sm" style="padding: 0 !important;">
            <div class="pb col next-button">
                <button type="submit" class="btn btn-primary"  [disabled]="!validInfo() || usuarioBloqueado">
                    Validar resposta &nbsp;
                    <fa-icon class="float-end" [icon]="['fas', 'check']" size="lg"></fa-icon>
                </button>
            </div>
          </div>
        </div>
    </div>
</form>